query allExtTennisPlayers(
  $first: Int,
  $offset: Int,
  $filter: TennisPlayerMappingFilter,
  ) {
  allTennisPlayerMappings(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      extId
      extRef
      feed
      mappingType
      mappingId
      createdAt
      createdBy
      intId
      playerIndex
      mappedEntity {
        name
        source
        playerId
        playerIndex
      }
      playerTeamMapping: playerTeamMappingsByFeedAndPlayerExtId {
        nodes {
          discriminator
          team: tennisTeamMapping { 
            extRef
          }
        }
      }
    }
    totalCount
  }
}
